// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const addFundChartSecurities = createAction('[Fund Chart] Add Fund Chart Securities', props());
export const removeFundChartSecurity = createAction('[Fund Chart] Remove Fund Chart Security', props());
export const setFundChartSecurities = createAction('[Fund Chart] Set Fund Chart Securities', props());
export const toggleFundChartSecurity = createAction('[Fund Chart] Toggle Fund Chart Security', props());
export const updateFundChartSecurityOrdering = createAction('[Fund Chart] Update Fund Chart Security Ordering', props());
